let faqTriggers = document.querySelectorAll('.js-faq-reborn-item');

faqTriggers.forEach(trigger => {
	trigger.addEventListener('click', () => {
		console.log(trigger)
		let content = trigger.querySelector('.js-faq-reborn-content');
		let icon = trigger.querySelector('.js-faq-reborn-icon')
		content.classList.toggle('is-visible');
		icon.classList.toggle('c-icon--plus');
		icon.classList.toggle('c-icon--minus');
	})
})

